export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; externalUrl?: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    // {
    //   name: 'dashboard',
    //   displayName: 'menu.dashboard',
    //   meta: {
    //     icon: 'vuestic-iconset-dashboard',
    //   },
    // },
    {
      name: 'cuentas_streaming',
      displayName: 'Cuentas Streaming',
      meta: {
        icon: 'smart_display',
      },
    },
    {
      name: 'oasistreaming',
      displayName: 'Oasistreaming',
      meta: {
        icon: 'live_tv',
        externalUrl: 'https://app.oasistreaming.com',
      },
    },
    // {
    //   name: 'consulta_streaming',
    //   displayName: 'Consultar Streaming',
    //   meta: {
    //     icon: 'search',
    //   },
    // },
    // {
    //   name: 'users',
    //   displayName: 'menu.users',
    //   meta: {
    //     icon: 'group',
    //   },
    // },
    // {
    //   name: 'projects',
    //   displayName: 'menu.projects',
    //   meta: {
    //     icon: 'folder_shared',
    //   },
    // },
    // {
    //   name: 'payments',
    //   displayName: 'menu.payments',
    //   meta: {
    //     icon: 'credit_card',
    //   },
    //   children: [
    //     {
    //       name: 'payment-methods',
    //       displayName: 'menu.payment-methods',
    //     },
    //     {
    //       name: 'pricing-plans',
    //       displayName: 'menu.pricing-plans',
    //     },
    //     {
    //       name: 'billing',
    //       displayName: 'menu.billing',
    //     },
    //   ],
    // },
    // {
    //   name: 'preferences',
    //   displayName: 'menu.preferences',
    //   meta: {
    //     icon: 'manage_accounts',
    //   },
    // },
    {
      name: 'settings',
      displayName: 'Configuración',
      meta: {
        icon: 'settings',
      },
    },
  ] as INavigationRoute[],
}
